import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { oneKlicks } from "../../../SDK/oneclick";
import { getuserdata } from "../../../services/apiService";

const LowStock = () => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = async () => {
        try {
            setLoading(true);
            const pharmacyId = await getuserdata("id");
            const res = await oneKlicks.read(
                "",
                "seller_pharmacy_products",
                { pharmacy_id: pharmacyId, stock_status: "low_stock" },
                "quantity ASC",
                {},
                { page: 1, limit: 100 }
            );
            setList(res?.success ? res.data || [] : []);
        } catch (e) {
            setList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    const getStockBadgeVariant = (status) => {
        switch (status?.toLowerCase()) {
            case "in_stock":
                return "success";
            case "low_stock":
                return "warning";
            case "out_of_stock":
                return "danger";
            default:
                return "secondary";
        }
    };

    return (
        <div className="container-fluid py-3">
            <div className="card mb-5">
                <div className="card-body">
                    <div className="align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <h5 className="mb-0 font-weight-bold mr-3" style={{ color: 'white' }}>Low Stock Alerts</h5>
                            <Badge bg="warning">Low Stock</Badge>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="table-responsive">
                        <table hover size="sm" className="mb-0 align-middle">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Brand</th>
                                    <th>Category</th>
                                    <th style={{ width: 120 }}>Quantity</th>
                                    <th>Stock Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : list.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-5">
                                            <h5 className="text-muted mb-2">No low stock items</h5>
                                            <p className="text-muted mb-3">
                                                All products are well stocked
                                            </p>
                                        </td>
                                    </tr>
                                ) : (
                                    list.map((r) => (
                                        <tr key={r.id}>
                                            <td data-label="Name" style={{ minWidth: 220 }}>
                                                <div style={{ fontWeight: '600', color: '#1890ff', marginBottom: '2px' }}>
                                                    {r.product_name}
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#666' }}>{r.manufacturer || ""}</div>
                                            </td>
                                            <td data-label="Brand">{r.brand || "-"}</td>
                                            <td data-label="Category">
                                                <Badge bg="primary">{r.category || "-"}</Badge>
                                            </td>
                                            <td data-label="Quantity" style={{ fontWeight: '600', color: '#ff4d4f' }}>
                                                {r.quantity}
                                            </td>
                                            <td data-label="Stock Status">
                                                <Badge bg={getStockBadgeVariant(r.stock_status)}>
                                                    {r.stock_status?.replace("_", " ") || "-"}
                                                </Badge>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LowStock;


